import { ReactElement } from 'react';
import { useUIDSeed } from 'react-uid';
import useNotifications from '../../../hooks/useNotifications';
import AddressBanner from '../../shared/banners/AddressBanner';
import AddressCard from './AddressCard';
import AddAddressSkeleton from './AddAddressSkeleton';
import AddAddressValue from './AddAddressValue';
import useAddresses from '../../../hooks/useAddresses';

function DeliveryAddress(): ReactElement {
  const { notifications } = useNotifications();
  const { addressChange } = notifications;

  const { addresses, reload } = useAddresses();
  const seed = useUIDSeed();

  const handleReload = () => {
    reload();

    setTimeout(() => {
      document.body.scrollIntoView({ behavior: 'smooth' });
    });
  };

  return (
    <>
      <div className="c-my-account__address">
        <div className="c-my-account__address__addresses-list">
          {addresses.length > 0 ? (
            <>
              {addresses.map((address) => (
                <div key={address.id}>
                  <AddressCard
                    address={address}
                    onUpdate={() => handleReload()}
                    key={address.id}
                  />
                </div>
              ))}

            </>
          ) : (
            [...Array(3)].map((el, i) => (
              <AddAddressSkeleton
                isPrimary={i === 0}/**/
                key={seed(i)}
              />
            ))
          )}
          <div>
            <AddAddressValue
              isHidden={!addresses.length}
              onAdd={() => handleReload()}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default DeliveryAddress;
